import taskProjectRoutes from "./projects";
import listTasksRoute from "./list-tasks-route";
import countTaskRoute from "./count-tasks-route";
import getTaskRoute from "./get-task-route";
import listTasksClientRoute from "./list-tasks-for-client-route";

export default {
  "projects": taskProjectRoutes,
  "list-tasks": listTasksRoute,
  "count-tasks": countTaskRoute,
  "list-tasks-for-client": listTasksClientRoute,
  "get-task": getTaskRoute,
};
